import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { IntroSplash } from "../components/IntroSplash";
import { CoursesFloatingWidget } from "../components/CoursesFloatingWidget";
import { FacebookEmbed } from "../components/FacebookEmbed";
import { HeroSection } from "../components/home/HeroSection";
import { TrendingSection, ChannelGridSection } from "../components/home/TrendingSection";
import { CreatorOfMonthSection } from "../components/home/CreatorOfMonthSection";
import { NewsSection } from "../components/home/NewsSection";

const EMPTY = { channels: [], videos: [], articles: [], creator: null };

const loadHome = () =>
  Promise.all([
    api.get("/channels"),
    api.get("/videos"),
    api.get("/articles?limit=3"),
    api.get("/admin/analytics/creator_of_month").catch(() => ({ data: null })),
  ]).then(([c, v, a, cm]) => ({
    channels: c.data,
    videos: v.data,
    articles: a.data,
    creator: cm.data?.winner ? cm.data : null,
  }));

export default function Home() {
  const [data, setData] = useState(EMPTY);
  const [introKey, setIntroKey] = useState(0);
  const replayIntro = () => { sessionStorage.removeItem("fv_intro_seen"); setIntroKey(k => k + 1); };

  useEffect(() => { loadHome().then(setData); }, []);

  const { channels, videos, articles, creator } = data;
  return (
    <div>
      <IntroSplash key={introKey} />
      <HeroSection featured={videos[0] || null} channels={channels} onReplayIntro={replayIntro} />
      <TrendingSection videos={videos} channels={channels} />
      <CreatorOfMonthSection creator={creator} />
      <FacebookEmbed height={500} />
      <NewsSection articles={articles} />
      <ChannelGridSection channels={channels} />
      <CoursesFloatingWidget />
    </div>
  );
}
